import { render, staticRenderFns } from "./EmailCampaign.vue?vue&type=template&id=297fe642&scoped=true"
import script from "./EmailCampaign.vue?vue&type=script&lang=js"
export * from "./EmailCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297fe642",
  null
  
)

export default component.exports